/* eslint-disable */

(function() {
	var ans, chose_mcq, random1, random2, complexity, qtype, anstype, maxn, minn, fibsign, mcq_userans, all_choice_id, all_choice_name, divider;
	var no_attempt = 0;
	var no_success = 0;
	var problem_limit = 10;
	var math_fact = -1;
	$(document).ready(function(){
		if ($('#flashcard_types').val() == "gtype1") {
			qtype = 1;
		}
		else if ($('#flashcard_types').val() == "gtype2") {
			qtype = 2;
		}
		else if ($('#flashcard_types').val() == "gtype3") {
			qtype = 3;
		}
		else if ($('#flashcard_types').val() == "gtype4") {
			qtype = 4;
		}
		
		if ($('#difficulty_options').val() == "difficult1") {
			complexity = 1;
		}
		else if ($('#difficulty_options').val() == "difficult2") {
			complexity = 2;
		}
		else if ($('#difficulty_options').val() == "difficult3") {
			complexity = 3;
		}
		else if ($('#difficulty_options').val() == "difficult4") {
			complexity = 4;
		}
		
		if ($('#answer_types').val() == "atype1") {
			anstype = 1;
		}
		else if ($('#answer_types').val() == "atype2") {
			anstype = 2;
		}

		problem_limit = $('#num_problems_select option:selected' ).text();
		
		if (isNaN($('#math_fact_select option:selected').text().trim())) {
			math_fact = -1;
		}
		else {
			math_fact = new Number($('#math_fact_select option:selected').text().trim());
		}
		
		start();
		$('#num_problems_select').change(function(){
			problem_limit = $('#num_problems_select option:selected' ).text();
			start();
		});
		$('#math_fact_select').change(function(){
			if (isNaN($('#math_fact_select option:selected').text().trim())) {
				math_fact = -1;
			}
			else {
				math_fact = new Number($('#math_fact_select option:selected').text().trim());
			}
			start();
		});
		$('.js-option_cont select').change(function(){
			all_choice_id = $(this).find('option:selected').val();
			all_choice_name = $(this).find('option:selected').attr('class');
			start();
		});
		$('.js-ans').click(function(){
			if (no_attempt > problem_limit) {
				return;
			}
			fib();
		});
		$('.fib_in').keypress(function(e) {
			if (no_attempt > problem_limit) {
				return;
			}
			if(e.which == 13) { 
				if (isIE() == false) {
					fib();
				}
			}
		});
		$('.fib_in').keyup(function(e) {
			if ($('#number_entry_options').val() == 'numberEntryRightToLeft') {
				$('#answer_input').setCursorPosition(0);
			}
		});
		$('.ans-choice').click(function(){
			if (no_attempt > problem_limit) {
				return;
			}
			var thisid = $(this).attr('id');
			var bb = thisid.match(/\d+/g);
			var thisidno = parseInt(bb);
			mcq(thisidno);
		});
		$('.js-restart').click(function(){
			start();
		});
	});

	//set cursor position
	$.fn.setCursorPosition = function(position){
			if(this.length == 0) return this;
			return $(this).setSelection(position, position);
	};

	//set selection range
	$.fn.setSelection = function(selectionStart, selectionEnd) {
	   if(this.length == 0) return this;
	    var input = this[0];
	    if (input.createTextRange) {
	        var range = input.createTextRange();
	        range.collapse(true);
	        range.moveEnd('character', selectionEnd);
	        range.moveStart('character', selectionStart);
	        range.select();
	    } else if (input.setSelectionRange) {
	        input.focus();
	        input.setSelectionRange(selectionStart, selectionEnd);
	    }
	    return this;
	};
		
	function isIE () {
	  var myNav = navigator.userAgent.toLowerCase();
	  return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
	}

	function start(){
		no_attempt = 0;
		no_success = 0;
		var stat_percent = 0;
		$('#stat_attempt').html(no_attempt);
		$('#stat_correct').html(no_success);
		$('#stat_percent').html(stat_percent + ' %');

		if (all_choice_name == 'gtype')
		{
			var bb = all_choice_id.match(/\d+/g);
			var thisidno = parseInt(bb);
			qtype = thisidno;
		}
		if (all_choice_name == 'difficult')
		{
			bb = all_choice_id.match(/\d+/g);
			thisidno = parseInt(bb);
			complexity = thisidno;
		}
		if (all_choice_name == 'atype')
		{
			bb = all_choice_id.match(/\d+/g);
			thisidno = parseInt(bb);
			anstype = thisidno;
		}
		if (anstype == 1) {
			$('.fib_cont').fadeIn(700);
			$('.mcq-cont').fadeOut(0);
			$('.fib_in').focus();
			$('.fib_in').val('');
			questionready();
		}
		else if (anstype == 2) {
			$('.mcq-cont').fadeIn(700);
			$('.fib_cont').fadeOut(0);
			mcq(0);
		}
		$('.msg-correct').css('display','none');
		$('.msg-incorrect').css('display','none');
		$('.js-final-content').css('display','none');

	}
	var chose = 0;
	function mcq(idno){
		chose_mcq = chose;
		if (idno != 0){
			
			mcq_userans = $('#a'+idno).html();
			if (idno == chose_mcq){
				success();
			}
			else if (idno != chose_mcq){
				failure();
			}
			statshow();
		}
		if (no_attempt == problem_limit) {
			var message = 'You got ' + no_success + ' out of ' + no_attempt + ' correct.';
			if (no_success == no_attempt) {
				message += ' Perfect!';
			}
			$('#final_message').html(message);
			$('.js-final-content').fadeIn(700);
			
			no_attempt++;
		}
		else {
			complexitySet();
			randomgenerator();
			mcq_ans_set();
			signfix();
		}
		$('.fib_cont').fadeOut(0);
		$('.mcq-cont').fadeIn(700);
		
	}

	function fib(){
		operation();
		var initans = $('.fib_in').val();
		var ans_fib = parseInt(initans);
		if (ans_fib == ans){
			success();
		}
		else if (ans_fib != ans){
			failure();
		}
		statshow();
		
		if (no_attempt == problem_limit) {
			var message = 'You got ' + no_success + ' out of ' + no_attempt + ' correct.';
			if (no_success == no_attempt) {
				message += ' Perfect!';
			}
			$('#final_message').html(message);
			$('.js-final-content').fadeIn(700);
			
			no_attempt++;
		}
		else {
			questionready();
		}
	}

	function questionready(){
		$('.fib_in').val('');
		complexitySet();
		randomgenerator();
		signfix();
	}

	function complexitySet(){
		if (complexity == 1){
			maxn = 8;
			minn = 0;
		}
		else if (complexity == 2){
			maxn = 12;
			minn = 1;
		}
		else if (complexity == 3){
			maxn = 18;
			minn = 1;
		}
		else if (complexity == 4){
			maxn = 100;
			minn = 1;
		}
	}

	var show_q1 = 0;
	var show_q2 = 0;

	function randomgenerator(){
		var lastrandom1 = random1;
		var lastrandom2 = random2;
		$('.fib_in').focus();
		if (qtype == 1 || qtype == 3){ // addition or multiplication
			if (complexity == 1 && qtype == 3) minn = 1;
			if (math_fact < 0) {
				while (random1 == lastrandom1) {
					random1 = Math.floor(Math.random() * (maxn - minn + 1)) + minn;
				}
				while (random2 == lastrandom2) {
					random2 = Math.floor(Math.random() * (maxn - minn + 1)) + minn;
				}
			}
			else {
				random1 = math_fact;
				while (random2 == lastrandom2) {
					random2 = Math.floor(Math.random() * (maxn - minn + 1)) + minn;
				}
			}
		}
		else if (qtype == 2){ // subtraction
			if (complexity == 1){minn = 1;}
			else if (complexity == 2){minn = 1;}
			else if (complexity == 3){minn = 1;}
			else if (complexity == 3){minn = 1;}
			if (math_fact < 0) {
				while (random1 == lastrandom1) {
					random1 = Math.floor(Math.random() * (maxn - minn + 1)) + minn;
				}
				var maxn1 = random1-1;
				var count = 0;
				while (random2 == lastrandom2 && count < 10) {
					random2 = Math.floor(Math.random() * (maxn1 - minn + 1)) + minn;
					count++;
				}
			}
			else {
				random1 = math_fact;
				maxn1 = random1-1;
				count = 0;
				while (random2 == lastrandom2 && count < 10) {
					random2 = Math.floor(Math.random() * (maxn1 - minn + 1)) + minn;
					count++;
				}
			}
		}
		else if (qtype == 4){ // division
			if (complexity == 1){
				minn = 1;
				var divmax = 8;
				var divmin = 1;
			}
			else if (complexity == 2){
				divmax = 12;
				divmin = 1;
			}
			else if (complexity == 3){
				divmax = 18;
				divmin = 8;
			}
			else if (complexity == 4){
				divmax = 100;
				divmin = 8;
			}
			if (math_fact < 0) {
				while (random2 == lastrandom2) {
					random2 = Math.floor(Math.random() * (maxn - minn + 1)) + minn;
				}
				while (random1 == lastrandom1) {
					divider = Math.floor(Math.random() * (divmax - divmin + 1)) + divmin;
					random1 = random2 * divider;
				}
			}
			else {
				if (math_fact == 0) {
					// need to set selected_math_fact to 1 here
					$('#math_fact_select').val('1');
					math_fact = 1;
				}
				random2 = math_fact;
				while (random1 == lastrandom1) {
					divider = Math.floor(Math.random() * (divmax - divmin + 1)) + divmin;
					random1 = random2 * divider;
				}
			}
		}

		show_q1 = random1;
		show_q2 = random2;
		$('.a').html(random1);
		$('.b').html(random2);
	}

	function mcq_ans_set(){
		chose = Math.floor(Math.random() * (4 - 1 + 1)) + 1;
		operation();
		$('#a' + chose).html(ans);
		
		var j = 0;
		var k = Math.floor(Math.random() * (4 - 1 + 1)) + 1;
		for (var i=1;i<=4;i++){
			if (i == chose){
				continue;
			}
			else{
				var ch1 = Math.floor(Math.random() * (2 - 1 + 1)) + 1;
				if(ch1 == 2 && j==0){
					if ((k == 1) && (ans-10>0)){
						$('#a' + i).html(ans-10);
					}
					else{
						$('#a' + i).html(ans+10);
					}
					j = 1;
					k++;
				}
				else if (ch1 == 1 && ans-i>0){
					$('#a' + i).html(ans-i);
				}
				else{
					$('#a' + i).html(ans+i);
				}
			}
		}
	}

	function success() {
		no_success++;
		if (anstype == 1){
			var user_ans = $('.fib_in').val();
		}
		else if (anstype == 2){
			user_ans = mcq_userans;
		}
		var success_html = show_q1 +' '+ fibsign + ' '+ show_q2 + ' = '+ user_ans;
		var success_html2 = 'Correct Answer!';
		
		$('.msg-correct').hide();
		$('.msg-correct').css('width',0);
		$('.msg-correct__upper-text p').html('');
		$('.msg-correct__lower-text p').html('');
		$( '.msg-correct' ).show();
		$( '.msg-correct' ).animate({width: '80%'}, 500, function() {
			$('.msg-correct .msg-correct__upper-text').html(success_html);
			$('.msg-correct .msg-correct__lower-text').html(success_html2);
		});

		$('.msg-incorrect').hide();
		$('.msg-incorrect').css('width',0);
		$('.msg-incorrect p').html('');
	}

	function failure() {
		if (anstype == 1){
			var user_ans = $('.fib_in').val();
		}
		else if (anstype == 2){
			user_ans = mcq_userans;
		}
		if (user_ans == '' || user_ans == null) user_ans = '--';
		var failure_html = 'Sorry, '+ show_q1 + ' ' + fibsign + ' '+ show_q2 + ' is not '+ user_ans + '.';
		var failure_html2 = show_q1+ ' '+ fibsign + ' ' +show_q2+ ' = '+ ans + ' is correct.';
		$('.msg-incorrect').hide();
		$('.msg-incorrect').css('width',0);
		$('.msg-incorrect p').html('');
		$( '.msg-incorrect' ).show();

		$( '.msg-incorrect' ).animate({width: '80%'}, 500, function() {
			$('.msg-incorrect .msg-incorrect__upper-text').html(failure_html);
			$('.msg-incorrect .msg-incorrect__lower-text').html(failure_html2);
		});
		$('.msg-correct').hide();
		$('.msg-correct').css('width',0);
		$('.msg-correct p').html('');
	}

	function signfix(){
		if (qtype == 1){$('.integers__sign').html('+'); fibsign = '+';}
		else if (qtype == 2){$('.integers__sign').html('-'); fibsign = '-';}
		else if (qtype == 3){$('.integers__sign').html('&#215;'); fibsign = '&#215;';}
		else if (qtype == 4){$('.integers__sign').html('&#247;'); fibsign = '&#247;';}
	}

	function operation(){
		if (qtype == 1){
			ans = random1 + random2;
		}
		else if (qtype == 2){
			ans = random1 - random2;
		}
		else if (qtype == 3){
			ans = random1 * random2;
		}
		else if (qtype == 4){
			ans = divider;
		}
		no_attempt++;
	}

	function statshow(){

		$('#stat_correct').html(no_success);
		$('#stat_attempt').html(no_attempt);
		var stat_percent = ((no_success / no_attempt) * 100);
		if (Math.floor(stat_percent) != stat_percent){
			stat_percent = stat_percent.toFixed(2);
		}
		$('#stat_percent').html(stat_percent + ' %');
	}
})();



/** WEBPACK FOOTER **
 ** ./client/app/scripts/vendor/flashcards.js
 **/